import React from 'react';

export const MobileAppsSection: React.FC = () => {
  const apps = [
    {
      name: 'Vavada Casino',
      rating: 4.9,
      size: '45 МБ',
      speed: 4.8,
      image: 'https://public.readdy.ai/ai/img_res/4baac46ecdba69f47c1d0f4a5f30fd9b.jpg',
      bgColor: 'bg-rose-100'
    },
    {
      name: 'Pin-Up Casino',
      rating: 4.8,
      size: '52 МБ',
      speed: 4.7,
      image: 'https://readdy.ai/api/search-image?query=casino%20mobile%20application%20interface%20with%20live%20dealer%20games%20and%20betting%20options%20on%20phone%20screen%2C%20mint%20green%20turquoise%20theme%2C%20sleek%20modern%20design%2C%20professional%20app%20preview%2C%20photorealistic%20quality&width=300&height=400&seq=31&orientation=portrait',
      bgColor: 'bg-emerald-100'
    },
    {
      name: '1xSlots',
      rating: 4.7,
      size: '58 МБ',
      speed: 4.6,
      image: 'https://readdy.ai/api/search-image?query=mobile%20gambling%20app%20showing%20tournament%20leaderboard%20and%20jackpot%20slots%20on%20smartphone%20display%2C%20soft%20gray%20silver%20theme%2C%20contemporary%20ui%20layout%2C%20professional%20mockup%2C%20high%20end%20render&width=300&height=400&seq=32&orientation=portrait',
      bgColor: 'bg-slate-100'
    },
    {
      name: 'Riobet',
      rating: 4.8,
      size: '48 МБ',
      speed: 4.9,
      image: 'https://readdy.ai/api/search-image?query=casino%20app%20interface%20displaying%20sports%20betting%20and%20live%20casino%20sections%20on%20mobile%20screen%2C%20warm%20amber%20peach%20theme%2C%20modern%20clean%20design%2C%20professional%20application%20preview%2C%20realistic%20quality&width=300&height=400&seq=33&orientation=portrait',
      bgColor: 'bg-amber-100'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Мобильные приложения казино онлайн
          </h2>
          <p className="text-xl text-gray-600">Рейтинг по удобству и скорости</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {apps.map((app, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className={`${app.bgColor} h-80 flex items-center justify-center p-4`}>
                <img
                  src={app.image}
                  alt={app.name}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{app.name}</h3>
                
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-base ${
                        i < Math.floor(app.rating) ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    ></i>
                  ))}
                  <span className="text-sm text-gray-600 ml-1">{app.rating}</span>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Размер:</span>
                    <span className="font-medium">{app.size}</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Загрузка:</span>
                    <span className="font-medium">{app.speed}/5</span>
                  </div>
                </div>

                <div className="flex gap-2 mb-4">
                  <div className="flex-1 bg-gray-100 rounded-lg p-2 flex items-center justify-center">
                    <i className="ri-apple-fill text-xl"></i>
                  </div>
                  <div className="flex-1 bg-gray-100 rounded-lg p-2 flex items-center justify-center">
                    <i className="ri-android-fill text-xl"></i>
                  </div>
                </div>

                <button className="w-full py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
                  Скачать
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};